// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"CartButton_cartButton__27qGV","badge":"CartButton_badge__3Xt5b","totalAmount":"CartButton_totalAmount__2ON8G"};